const ADSENSE_CLIENT = 'ca-pub-7342205136361272';

const runtimeSlots =
    (typeof window !== 'undefined' && window.__ADSENSE_SLOTS__) || {};

const runtimeAffiliates =
    (typeof window !== 'undefined' && window.__AFFILIATES__) || {};

const PROD_API = 'https://worldauto-backend-production.up.railway.app';
const LOCAL_API = 'http://localhost:5000';

const isLocalHost =
    typeof window !== 'undefined' &&
    /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

export default {
    baseUrl: isLocalHost ? LOCAL_API : PROD_API,
    adsense: {
        enabled: true,
        client: ADSENSE_CLIENT,
        slots: {
            searchInFeed: runtimeSlots.searchInFeed || '',
            valuator: runtimeSlots.valuator || '',
            modelGuide: runtimeSlots.modelGuide || '',
            calculator: runtimeSlots.calculator || '',
            ...runtimeSlots,
        },
    },
    affiliates: {
        vin: {
            url: runtimeAffiliates.vin?.url || '',
            partner: runtimeAffiliates.vin?.partner || '',
        },
    },
};
